// True only when the app is served from a dev machine (localhost). Used to
// show developer-only UI — per-model token usage, the usage reset button —
// which stays hidden for real users on the deployed site.
function isLocalDev() {
  if (typeof window === 'undefined' || !window.location) return false;
  var hostname = String(window.location.hostname || '').toLowerCase();
  return hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '[::1]';
}

module.exports = { isLocalDev: isLocalDev };
